export default "__VITE_ASSET__0VIuaApe__"